import { faThermometer, faBattery2, faDumpster } from "@fortawesome/free-solid-svg-icons";

const MeasureColors = {
    color: {
        filling: {
            backgroundColor: "rgba(0, 151, 255, 0.5)",
            borderColor: "rgb(82, 161, 251)",
            icon: `path://${faDumpster.icon[4]}`,
        },
        battery_one: {
            backgroundColor: "rgba(255, 159, 64, 0.5)",
            borderColor: "rgb(255, 159, 64)",
            icon: `path://${faBattery2.icon[4]}`,
        },
        battery: {
            backgroundColor: "rgba(255, 159, 64, 0.5)",
            borderColor: "rgb(255, 159, 64)",
            icon: `path://${faBattery2.icon[4]}`,
        },
        voltage: {
            backgroundColor: "rgba(0, 151, 255, 0.5)",
            borderColor: "rgb(82, 161, 251)",
            icon: `path://${faDumpster.icon[4]}`,
        },
        temperature: {
            backgroundColor: "rgba(255, 99, 132, 0.5)",
            borderColor: "rgb(255, 99, 132)",
            icon: `path://${faThermometer.icon[4]}`,
        },

        // Color por defecto para cualquier medida que no tenga un color específico
        default: {
            backgroundColor: "rgba(201, 203, 207, 0.5)",
            borderColor: "rgb(201, 203, 207)",
            icon: "circle",
        },
        measure: {
            backgroundColor: "rgba(0, 151, 255, 0.5)",
            borderColor: "rgb(82, 161, 251)",
            icon: `path://${faDumpster.icon[4]}`,
        },
    },
    getColor: function (measureType) {
        if (measureType && measureType in this.color) {
            return this.color[measureType];
        }
        return this.color.default;
    },
};

export default MeasureColors;
